
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacyPolicy.html",
      function () {
        return require("private-next-pages/privacyPolicy.html.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacyPolicy.html"])
      });
    }
  